module.exports = __webpack_public_path__ + "media/images/flags/gy-1a50381e56e0c65af5ca78ee4aa6e566.svg";